import { render, staticRenderFns } from "./TableBudgetCategory.vue?vue&type=template&id=8a252694&"
import script from "./TableBudgetCategory.vue?vue&type=script&lang=js&"
export * from "./TableBudgetCategory.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetCategory.vue?vue&type=style&index=0&id=8a252694&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports